import { LogoCategoriesComponent } from './logo-categories';
export const LogoCategories = LogoCategoriesComponent;